// Copyright (c) RoochNetwork
// SPDX-License-Identifier: Apache-2.0

export const DEFAULT_MAX_GAS_AMOUNT = 1000000
